<script>
import annotationPlugin from "chartjs-plugin-annotation";
import { Chart as ChartJS, BarController, BarElement, Tooltip } from "chart.js";
import ChartJSBase from "./chart_js_base.vue";
ChartJS.register(Tooltip);
ChartJS.register(BarElement);
ChartJS.register(BarController);
ChartJS.register(annotationPlugin);

export default {
  name: "ChartJSBar",

  extends: ChartJSBase,

  data() {
    return {
      type: "bar",
    };
  },
};
</script>
